import { StepItem, StepState } from "../../../../../../models";
import { Stepper } from "../../../../../../widget";
import { useNewProjectJourneyContext } from "../../NewProjectJourneyContext";
import { isPartiallyCreated } from "../../utils";

export const NewProjectStepper = (): JSX.Element => {
  const { steps, currentStep, inProgressStep, goToStep, currentUserType, state } = useNewProjectJourneyContext();
  // The access step's own Previous is closed off once Save is clicked; the stepper must not reopen it.
  const isNavigationLocked = state.isSaveAttempted || isPartiallyCreated(state.details, state.createdProjects);

  const inProgressIndex = steps.findIndex((step) => step.key === inProgressStep);
  const currentIndex = steps.findIndex((step) => step.key === currentStep);

  const items: StepItem[] = steps.map((step, index) => {
    // Every reached step goes grey; indigo follows the step being viewed, not the furthest reached,
    // so stepping back re-colours it.
    let stepState = StepState.NotStarted;
    if (index <= inProgressIndex) stepState = StepState.Complete;
    if (index === currentIndex) stepState = StepState.InProgress;

    return { key: step.key, stepName: step.key, stepState };
  });

  return (
    <Stepper
      steps={items}
      currentSubStepKey={currentStep}
      currentUserType={currentUserType}
      variant="indigo"
      hideDividers
      // Only steps already reached are navigable; jumping ahead would skip validation.
      onClick={(stepKey) => {
        if (isNavigationLocked) return;
        const targetIndex = steps.findIndex((step) => step.key === stepKey);
        if (targetIndex !== -1 && targetIndex <= inProgressIndex) goToStep(steps[targetIndex].key);
      }}
    />
  );
};
